import { useEffect } from 'react';
import { useAppSelector } from '.';
import { selectIsRequestStart } from '@/redux/selectors/signalRSelectors';

export const useSignalR = () => {
  const isAuthenticated = useAppSelector(state => !!state.auth.token);
  const requestStart = useAppSelector(selectIsRequestStart);

  useEffect(() => {
    if (isAuthenticated && requestStart) {
      let cancelled = false;
      import('@/lib/signalR').then(({ startSignalR }) => {
        if (!cancelled) startSignalR();
      });
      return () => {
        cancelled = true;
        import('@/lib/signalR').then(({ stopSignalR }) => stopSignalR());
      };
    }
  }, [isAuthenticated, requestStart]);
};
